import { UpdateCustomAttributeInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const customAttributeUpdateMutationAtom = createMutationAtomFactory(
  'settings.customAttributeUpdate',
  (input: UpdateCustomAttributeInput) => ({
    coreCustomAttributeUpdate: {
      __args: {
        input: {
          id: input.id,
          name: input.name,
          constraints: input.constraints,
          isDisabled: input.isDisabled,
          order: input.order,
        },
      },
      id: true,
    },
  }),
);
